<div class="document-editor-container">
  @if(showEditor) {
  <document-editor #docEditor class="document-editor" id="{{editorId}}" [documentServerUrl]="onlyOfficeServer + '/'"
    [config]="config" [events_onDocumentReady]="onDocumentReady" [onLoadComponentError]="onLoadComponentError"
    [events_onDocumentStateChange]="onDocumentStateChange"></document-editor>
  }
</div>